import { render, staticRenderFns } from "./TextBoxItem.vue?vue&type=template&id=517f4378&"
import script from "./TextBoxItem.vue?vue&type=script&lang=js&"
export * from "./TextBoxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports